import {createContext, getContextOrThrow} from 'src/core';
import type {Readable} from 'svelte/store';
import {writable} from 'svelte/store';

const pageContextKey = Symbol('page-ctx-key');

interface PageDataContext<STATIC, REACTIVE> {
    staticData: STATIC,
    reactiveData: Readable<REACTIVE>,
    updateReactiveData: (data: REACTIVE) => void
}

export function createPageContext<STATIC_DATA, REACTIVE_DATA = unknown>(staticData: STATIC_DATA = undefined, reactiveData?: REACTIVE_DATA): PageDataContext<STATIC_DATA, REACTIVE_DATA> {
    const reactiveDataStore = writable<REACTIVE_DATA>(reactiveData);

    return createContext<PageDataContext<STATIC_DATA, REACTIVE_DATA>>(pageContextKey, {
        staticData,
        reactiveData: reactiveDataStore,
        updateReactiveData: (data) => reactiveDataStore.set(data)
    });
}

export function getPageContext<STATIC_DATA, REACTIVE_DATA = unknown>(): PageDataContext<STATIC_DATA, REACTIVE_DATA> {
    return getContextOrThrow<PageDataContext<STATIC_DATA, REACTIVE_DATA>>(pageContextKey);
}